export interface CompanyProductPhaseUserPermissions {
  can_create_tasks_on_backlog: boolean;
  can_edit_backlog: boolean;
  can_edit_board: boolean;
  can_drag_in_board: boolean;
  can_archive_or_delete_tasks: boolean;
  can_mark_tasks_as_ready: boolean;
  can_request_client_approval: boolean;
  can_only_create_issues: boolean;
  can_act_as_product_manager: boolean;
}

export const EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS: CompanyProductPhaseUserPermissions = {
  can_create_tasks_on_backlog: false,
  can_edit_backlog: false,
  can_edit_board: false,
  can_drag_in_board: false,
  can_archive_or_delete_tasks: false,
  can_mark_tasks_as_ready: false,
  can_request_client_approval: false,
  can_only_create_issues: false,
  can_act_as_product_manager: false,
};

export interface CompanyProductUserPermissions {
  can_act_as_product_manager: boolean;
}
